
import WithModel from '@/mixins/withModel';
import * as OM from '@/model'
import { ModalServices } from '@/services/ModalServices';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ProjectConfigClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class fiscalData extends mixins(WithModel) {

    declare localValue: OM.BaseUser;
    codFiscError: boolean = false;
    codFiscNonCoerente: boolean = false;
    get needsFiscalCode(){
        return this.localValue.personalData.country == 'Italy' || this.localValue.personalData.country == 'Italia';
    }


    @Watch('localValue.personalData.country')
    onCountryChange(next, prev){
        if(this.needsFiscalCode){
            if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
                this.checkValidityCodiceFiscale();
        } else {
            this.$store.state.formErrors.codiceFiscale = false;
        }
    }

    @Watch('localValue.personalData.name')
    onNameChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
    }

    @Watch('localValue.personalData.surname')
    onSurnameChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
    }

    @Watch('localValue.fiscalData.sex')
    onSessoChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
    }

    @Watch('localValue.fiscalData.birthPlace')
    onBirthPlaceChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
    }

    @Watch('localValue.fiscalData.birthDate')
    onBirthDateChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
    }

    @Watch('localValue.fiscalData.fiscalCode')
    onCodiceFiscaleChange(next, prev){
        if(this.localValue.fiscalData.fiscalCode && this.localValue.fiscalData.fiscalCode.length == 16)
            this.checkValidityCodiceFiscale();
        else
            this.$store.state.formErrors.codiceFiscale = true;
    }

    checkValidityCodiceFiscale(){
        if(!this.needsFiscalCode)
            return;


        this.$store.state.formErrors.codiceFiscale = false;
        this.codFiscError = false;
        try {
            let inverso = utils.CodFiscInverso(this.localValue.fiscalData.fiscalCode);
            this.localValue.fiscalData.birthDate = new Date(inverso.year, inverso.month - 1, inverso.day).toISOString();
            this.localValue.fiscalData.sex = inverso.gender;
            this.localValue.fiscalData.birthPlace = inverso.birthplace;
            let calculated = utils.CalcolaCodFisc(this.localValue.fiscalData.name, this.localValue.fiscalData.surname, (<any>this.localValue.fiscalData.sex), inverso.day, inverso.month, inverso.year, inverso.birthplace, inverso.birthplaceProvincia);
            if(calculated.cf == inverso.cf){
                this.$store.state.formErrors.codiceFiscale = false;
                this.codFiscNonCoerente = false;
            } else {
                this.$store.state.formErrors.codiceFiscale = true;
                this.codFiscNonCoerente = true;
            }
        } catch(ex){
            this.codFiscError = true;
            this.$store.state.formErrors.codiceFiscale = true;
        }
    }

    alertFiscalCode(){
        if(!this.needsFiscalCode)
            return;

        ModalServices.alertModal(
            '',
            LocalizationServices.GetLocalizedValue('Calcolato dal codice fiscale', 'Calcolato dal codice fiscale')
        )
    }

}
